import React from 'react';
import { Wrapper, Progress } from './components'

export const ProgressBar = (props) => {
  const { progress, reversed, secondColor, color, height } = props;

  return (
    <Wrapper height={height} secondColor={secondColor} reversed={reversed}>
      <Progress color={color} progress={progress} />
    </Wrapper>
  )
}
